
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/antavo",
      function () {
        return require("private-next-pages/destinations/antavo.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/antavo"])
      });
    }
  